import React, { useContext, useEffect, useState } from 'react';
import { MainContext } from '../../App';
import useGetChatsOnSearch from '../../hooks/useGetChatsOnSearch';
import CharlyChatList from './CharlyChatList';
import CharlyChatWindow from './CharlyChatWindow';
import ModalLayout from '../GeneralComponents/Modal/ModalLayout';
import cookie from '../../common/cookie';
import { Sidebar } from "primereact/sidebar";
import ModelCao from './ModalForm/ModelCao';

export const CharlyChatContext = React.createContext();

function CharlyChat() {
  const { userId, amountPerPage } = useContext(MainContext);

  const [chatsDataList, setChatsDataList] = useState([]);
  const [chatId, setChatId] = useState('new');
  const [chatCurrentPage, setChatCurrentPage] = useState(1);
  const [chatSearchData, setChatSearchData] = useState({});
  const [loadingChat, setLoadingChat] = useState(false);
  const [chatTotalCount, setChatTotalCount] = useState(0);
  const [chatToDeleteId, setChatToDeleteId] = useState(0);
  const [messages, setMessages] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [menuVisible, setMenuVisible] = useState(false);
  const [caoOption, setCaoOption] = useState(() => cookie.get("Chatbot_CaoOption") ?? '')

  let [action, setAction] = useState({}),
      [show, setShow] = useState(false),
      [showSpinner, setShowSpinner] = useState(false),
      [spinnerText, setSpinnerText] = useState('');

  function selectCaoOption(option) {
    cookie.set("Chatbot_CaoOption", option, 7);
    setCaoOption(option);
    setShow(false)
  }

  useEffect(() => {
    if(caoOption === '' && !show) {
        setAction({action:'change-cao', title: 'Waar ben je werkzaam?', size:'sm', component: <ModelCao/>, forced: true});
        setShow(true);
    }
  }, [caoOption, show]);

  useEffect(() => {
    const chatData = {
      UserId: userId,
      CurrentPage: chatCurrentPage,
      AmountPerPage: amountPerPage,
    };
    setChatSearchData(chatData);
  }, [userId, amountPerPage, chatCurrentPage]);

  const { chats } = useGetChatsOnSearch(chatSearchData);

  const closeModal = () => {
    setShow(false);
  }

  useEffect(() => {
    if (!chats || !chats['page-items']) return;
    if(chatSearchData.CurrentPage === 1){
      setChatsDataList(chats['page-items'])
    }
    else {
      setChatsDataList(prev => ([...(prev || []), ...chats['page-items']]));
    }
    setChatTotalCount(chats['total-count']);
  }, [chats]);

  useEffect(() => {
    if(chatId === 'new'){
      const welcomeMessageCharly = [
        {
          'id': 0,
          'chat-id': 0,
          'user-input': 'Hoi Charly, zou je jezelf willen voorstellen en uitleggen waarvoor ik bij jou terecht kan?',
          'agent-answer': `Hoi! Ik ben Charly, jouw digitale collega bij Shoeby. Je kunt mij vragen stellen over:

- HR en procedures
- Werkinstructies
- Informatie uit Shoeby Inside zoals POS materiaal, VM bestanden, routes en meer

Stel gerust je vraag, dan help ik je zo snel mogelijk verder!`
        }
      ];
      setMessages(welcomeMessageCharly);
      setTotalCount(0);
    }
  }, [chatId])

  return (
    <CharlyChatContext.Provider
      value={{
        chatsDataList,
        chatId,
        setChatId,
        chatCurrentPage,
        setChatCurrentPage,
        loadingChat,
        setLoadingChat,
        setChatSearchData,
        chatTotalCount,
        action, setAction,
        show, setShow,
        showSpinner, setShowSpinner,
        spinnerText, setSpinnerText,
        chatToDeleteId, setChatToDeleteId,
        messages, setMessages,
        totalCount, setTotalCount,
        setMenuVisible,
        selectCaoOption, caoOption
      }}
    >
      <ModalLayout action={action} closeModal={closeModal} show={show} showSpinner={showSpinner} spinnerText={spinnerText} />

      <Sidebar visible={menuVisible} onHide={() => setMenuVisible(false)} className="p-sidebar-md sideBarChat" position="left" showCloseIcon>
        <CharlyChatList chats={chatsDataList} />
      </Sidebar>

      <div className="charlyChat">
        <div className="row">
          <div className="col-12">
            <CharlyChatWindow />
          </div>
        </div>
      </div>
    </CharlyChatContext.Provider>
  );
}

export default CharlyChat;
